import { ResponseDetail } from '@/interfaces/indicator-detail';
import { removeUndefinedKeys } from '@/utils/funtion';
import { getMethod } from '@/services/apis/http-server';

export const getIndicatorDetail = async (params: any) => {
  const newParams = removeUndefinedKeys(params);
  try {
    const response = await getMethod(`client/detail`, newParams);
    return response;
  } catch (error) {
    return {
      status: false,
      detail: undefined,
      related: [],
      keySearchData: [],
      popuplarSearch: [],
    } as unknown as ResponseDetail;
  }
};
